module.exports = __webpack_public_path__ + "static/media/video.326d5d01.mp4";